import * as tslib_1 from "tslib";
import { Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { FieldType } from '../../../core';
var FormlyFieldMultiCheckbox = (function (_super) {
    tslib_1.__extends(FormlyFieldMultiCheckbox, _super);
    function FormlyFieldMultiCheckbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormlyFieldMultiCheckbox.createControl = function (model, field) {
        var controlGroupConfig = field.templateOptions.options.reduce(function (previous, option) {
            previous[option.key] = new FormControl(model ? model[option.key] : undefined);
            return previous;
        }, {});
        return new FormGroup(controlGroupConfig, field.validators ? field.validators.validation : undefined, field.asyncValidators ? field.asyncValidators.validation : undefined);
    };
    return FormlyFieldMultiCheckbox;
}(FieldType));
FormlyFieldMultiCheckbox = tslib_1.__decorate([
    Component({
        selector: 'formly-field-multicheckbox',
        template: "\n    <div *ngFor=\"let option of to.options\" class=\"checkbox\">\n      <label class=\"custom-control custom-checkbox\">\n        <input type=\"checkbox\" [value]=\"option.value\" [formControl]=\"formControl.get(option.key)\"\n        [formlyAttributes]=\"field\" class=\"custom-control-input\">\n        {{ option.value }}\n        <span class=\"custom-control-indicator\"></span>\n      </label>\n    </div>\n  ",
    })
], FormlyFieldMultiCheckbox);
export { FormlyFieldMultiCheckbox };
//# sourceMappingURL=multicheckbox.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/types/multicheckbox.js
// module id = 774
// module chunks = 3